import styled from 'styled-components/macro';

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;
`;

export const Message = styled.p`
    color: #c0392b;
    margin: 8px 0 0 0;
`;

export const LineRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const LineImage = styled.img`
    width: 64px;
    height: 64px;
    object-fit: contain;
    flex-shrink: 0;
`;

export const LineInfo = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 0;
`;
